import BaseAPI from "@/apis/base/baseApi";
import httpClient from "@/apis/base/httpclient";
import { MSEnum } from '@/commons/enumeration'
class JobTitleAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "TaskGo";
  controllerName = "jobtitles";

  /**
   * Lấy danh sách Chức vụ
   * NTDIEM 11/04/2023
   * @param {*} payload 
   * @returns 
   */
  getJobTitleByPaging(payload) {
    let request = {
      url: this.getAPIUrl() + '/list',
      data: payload
    };
    return httpClient.postAsync(request)
  }

  /**
  * save Chức vụ
  * vdgiang 27/3/2023
  */
  save(payload) {
    let request = {
      url: this.getAPIUrl(),
      data: {
        Ignores: [],
        Model: payload,
        ReturnRecord: true
      }
    };
    if (payload.State == MSEnum.ModelState.Update) {
      return httpClient.putAsync(request);
    }
    return httpClient.postAsync(request);
  }

  /**
   * Lấy dữ liệu chức vụ
   * NTDIEM 12/04/2023
   * @param {*} payload 
   * @returns 
   */
  getJobtitle(payload) {
    let request = {
      url: this.getAPIUrl() + `/edit/${payload}`,
    };

    return httpClient.getAsync(request);
  }

  /**
     * Them/Sua/Xoa nhieu
     * @param {*} payload 
     * @returns 
     * CreateBy: NTDIEM 12/04/2023
     */
  async multiSubmit(payload) {
    let request = {
      url: this.getAPIUrl() + "/submit",
      data: payload
    };

    return await httpClient.postAsync(request, true);
  }

  /**
   * Lấy số lượng chức vụ
   * @param {string} filter filter
   * @param {string} columns danh sách cột lấy về
   * @returns Số chức vụ
   * @author: NTDIEM 12/04/2023
   */
  getPagingSummary(filter = '', columns = '') {
    let request = {
      url: `${this.getAPIUrl()}/list-summary`,
      data: {
        filter,
        columns,
      }
    };
    return httpClient.postAsync(request);
  }

  /**
   * Lấy dữ liệu chức vụ
   * NTDIEM 12/04/2023
   * @param {*} payload 
   * @returns 
   */
  async getEdit(payload) {
    let request = {
      url: this.getAPIUrl() + `/edit/${payload.id}`,
    };

    return await httpClient.getAsync(request);
  }

  /**
   * Xóa chức vụ
   * @param {*} payload 
   * @returns 
   */
  async delete(payload) {
    let request = {
      url: this.getAPIUrl(),
      data: payload
    };

    return await httpClient.deleteAsync(request);
  }

  /**
     * Thêm/sửa/xóa nhiều
     */
  async submit(payload) {
    let request = {
      url: this.getAPIUrl() + "/submit",
      data: payload
    };

    return await httpClient.postAsync(request, true);
  }
}

export default new JobTitleAPI();